import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Wind, User } from "lucide-react";
import { scrollToId, PRICE } from "./shared";

const LINKS = [
  { label: "Chapters", href: "#chapters", testid: "nav-link-chapters" },
  { label: "Missions", href: "#missions", testid: "nav-link-missions" },
  { label: "Specs", href: "#specs", testid: "nav-link-specs" },
  { label: "Pricing", href: "#pricing", testid: "nav-link-pricing" },
  { label: "FAQ", href: "#faq", testid: "nav-link-faq" },
];

export const Nav = ({ onBuy }) => {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-40 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-carbon/70 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="nav-brand"
          onClick={() => scrollToId("#top")}
          className="flex items-center gap-2 font-display text-sm font-bold tracking-widest uppercase"
        >
          <Wind className="h-5 w-5 text-volt" strokeWidth={2.5} />
          <span>
            X8<span className="text-volt">/</span>Violent Fan
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => scrollToId(l.href)}
              className="font-mono text-xs tracking-[0.25em] uppercase text-smoke transition-colors duration-200 hover:text-volt"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            data-testid="nav-account-link"
            href="/account"
            className="text-smoke transition-colors duration-200 hover:text-volt"
            aria-label="My account"
          >
            <User className="h-5 w-5" />
          </a>
          <button
            data-testid="nav-buy-button"
            onClick={onBuy}
            className="border border-volt bg-volt px-5 py-2.5 font-mono text-xs font-bold tracking-[0.2em] uppercase text-ink transition-colors duration-200 hover:bg-transparent hover:text-volt"
          >
            Get X8 — ${PRICE}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
